import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { InboxOutlined } from '@mui/icons-material';
import { color, radius } from '../../theme/tokens';

// Neutral empty state with optional call to action.
const EmptyState = ({ icon, title = 'Nothing here yet', description, actionLabel, onAction, compact = false }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      py: compact ? 4 : 7,
      px: 3,
    }}
  >
    <Box
      sx={{
        width: 44, height: 44,
        borderRadius: `${radius.lg}px`,
        bgcolor: color.ink[100],
        color: color.ink[400],
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        mb: 1.5,
      }}
    >
      {icon || <InboxOutlined sx={{ fontSize: 22 }} />}
    </Box>
    <Typography sx={{ fontSize: '0.9375rem', fontWeight: 600, color: color.ink[800] }}>{title}</Typography>
    {description && (
      <Typography sx={{ mt: 0.5, fontSize: '0.8125rem', color: color.ink[500], maxWidth: 380 }}>
        {description}
      </Typography>
    )}
    {actionLabel && onAction && (
      <Button variant="outlined" size="small" onClick={onAction} sx={{ mt: 2 }}>
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default EmptyState;
